import {
  loader_styles_default
} from "./chunk.35G4SQUN.js";
import {
  lockBodyScrolling,
  unlockBodyScrolling
} from "./chunk.XS4D3FDG.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  e3 as e2,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass,
  __spreadProps,
  __spreadValues
} from "./chunk.K2NRSETB.js";

// src/components/loader/loader.ts
import { t } from "i18next";
var FadvLoader = class extends s {
  constructor() {
    super(...arguments);
    this.open = false;
    this.scope = "page";
    this.message = "";
    this.duration = 3e3;
    this.mode = "transparent";
  }
  firstUpdated() {
    this.base.hidden = !this.open;
    if (this.open) {
      this.openLoader();
    }
  }
  show() {
    this.open = true;
  }
  hide() {
    this.open = false;
  }
  disconnectedCallback() {
    if (this.open && this.scope === "page") {
      unlockBodyScrolling(this);
    }
    super.disconnectedCallback();
  }
  handleOpenChange() {
    if (this.open) {
      this.openLoader();
      emit(this, "sl-after-show");
    } else {
      this.closeLoader();
      emit(this, "sl-after-hide");
    }
  }
  openLoader() {
    this.configureVisibleScope();
    this.enableAnimations();
    this.base.hidden = false;
  }
  closeLoader() {
    this.configureHiddenScope();
    this.disableAnimations();
    this.base.hidden = true;
  }
  configureVisibleScope() {
    if (this.scope === "page") {
      lockBodyScrolling(this);
    } else if (this.scope === "parent" && this.parentElement) {
      this.parentPosition = getComputedStyle(this.parentElement).position;
      this.parentElement.style.position = "relative";
    }
  }
  configureHiddenScope() {
    if (this.scope === "page") {
      unlockBodyScrolling(this);
    } else if (this.scope === "parent" && this.parentElement) {
      this.parentElement.style.position = this.parentPosition;
    }
  }
  enableAnimations() {
    const timeout = this.duration / 3;
    const delay = this.duration / 6;
    const delayOffset = delay / 5;
    setTimeout(() => {
      [...this.dots].forEach((dot, index) => {
        stopAnimations(dot);
        const animation = getAnimation(dot, "loader-dot");
        animateTo(dot, animation.keyframes, __spreadProps(__spreadValues({}, animation.options), { duration: this.duration, delay: delay - delayOffset * index }));
      });
    }, timeout);
  }
  disableAnimations() {
    [...this.dots].forEach((dot) => {
      stopAnimations(dot);
    });
  }
  renderTitle() {
    if (!this.message)
      return w;
    return $`<fadv-typography id="loader__message" type="heading-medium" weight="500">${this.message}</fadv-typography>`;
  }
  render() {
    return $`<div role="alert" aria-live="assertive" aria-label=${l(!this.message ? t("components:loader.loading") : void 0)} aria-labelledby=${l(this.message ? "loader__message" : void 0)} class=${o({
      loader: true,
      "loader--page": this.scope === "page",
      "loader--parent": this.scope === "parent",
      "loader--monochrome": this.variant === "monochrome",
      "loader--transparent": this.mode === "transparent",
      "loader--opaque": this.mode === "opaque"
    })} ><div class="loader__inner">${this.renderTitle()}<div class="loader__dot">&#9679;</div><div class="loader__dot">&#9679;</div><div class="loader__dot">&#9679;</div><div class="loader__dot">&#9679;</div><div class="loader__dot">&#9679;</div><div class="loader__dot">&#9679;</div></div></div>`;
  }
};
FadvLoader.styles = loader_styles_default;
__decorateClass([
  i(".loader")
], FadvLoader.prototype, "base", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvLoader.prototype, "open", 2);
__decorateClass([
  e({ reflect: true })
], FadvLoader.prototype, "scope", 2);
__decorateClass([
  e({ reflect: true })
], FadvLoader.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], FadvLoader.prototype, "message", 2);
__decorateClass([
  e({ type: Number })
], FadvLoader.prototype, "duration", 2);
__decorateClass([
  e()
], FadvLoader.prototype, "mode", 2);
__decorateClass([
  e2(".loader__dot")
], FadvLoader.prototype, "dots", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], FadvLoader.prototype, "handleOpenChange", 1);
FadvLoader = __decorateClass([
  n("fadv-loader")
], FadvLoader);
setDefaultAnimation(`loader-dot`, {
  keyframes: [
    { opacity: 0, transform: "translateX(-300px)" },
    { opacity: 1, transform: "translateX(0px)" },
    { opacity: 1, transform: "translateX(0px)" },
    { opacity: 0, transform: "translateX(300px)" }
  ],
  options: {
    easing: "ease-in-out",
    iterations: Infinity
  }
});

export {
  FadvLoader
};
